import type { ResolvedNode } from '../../../../vendor/agentplace-a2ui/walker.ts';

/** Only a single-child vertical composition passes its standalone framing to its child. */
export function hasStandaloneChild(node: ResolvedNode, standalone: boolean): boolean {
  return (
    standalone &&
    node.component === 'Column' &&
    node.children.length === 1 &&
    node.danglingChildIds.length === 0
  );
}
